import { useContext } from 'react';
import { useLocation } from 'wouter';
import { useApiClient } from '@/hooks/useApiClient';
import { useAppStartupPrefetch } from '@/hooks/usePrefetch';
import { AuthContext } from '@/contexts/AuthContext';

export function AppInitializer({ children }: Readonly<{ children: React.ReactNode }>) {
  // Initialize API client with environment
  useApiClient();

  // Run startup prefetch after authentication
  // Use useContext directly to avoid throwing error in tests without AuthProvider
  const authContext = useContext(AuthContext);
  const isAuthenticated = authContext?.isAuthenticated ?? false;
  const [location] = useLocation();
  const isAgentRoute = location === '/agents' || location.startsWith('/agents/');

  // Prefetch commonly needed data in background after auth
  // Agent routes own their evidence loading and must not prefetch exchange surfaces.
  useAppStartupPrefetch(isAuthenticated && !isAgentRoute);

  return <>{children}</>;
}
